export default "__VITE_ASSET__DrZ4K9aQ__"